import React, { useState } from 'react';
import classes from './AgeGate.module.scss';
import Button from '../UI/Button/Button';
import moment from 'moment';


const AgeGate = props => {
    const {onAgeEntered} = props;
    const [month, setMonth] = useState(null);
    const [day, setDay] = useState(null);
    const [year, setYear] = useState(null);
    const [
        legalAge, 
        // setLegalAge
    ] = useState(21);
    const [
        // isOfLegalAge
        ,setIsOfLegalAge] = useState(false);
    const [formTitle, setFormTitle] = useState('WE NEED TO CHECK YOUR ID');

    const handleChangeOnMonth = (object) => {        
        if (object.target.value.length > object.target.maxLength) {            
          object.target.value = object.target.value.slice(0, object.target.maxLength)        
          setMonth(object.target.value);
        } else if(object.target.value > object.target.max) {
            object.target.value = null;
        } else {
            setMonth(object.target.value);
        }
    }

    const handleChangeOnDay = (object) => {        
        if (object.target.value.length > object.target.maxLength) {            
          object.target.value = object.target.value.slice(0, object.target.maxLength)        
            setDay(object.target.value);
        } else if(object.target.value > object.target.max) {
            object.target.value = null;
        } else {
            setDay(object.target.value);
        }
    }

    const handleChangeOnYear = (object) => {
        if (object.target.value.length > object.target.maxLength) {            
            object.target.value = object.target.value.slice(0, object.target.maxLength)        
            setYear(object.target.value);
        } else if(object.target.value > object.target.max) {
            object.target.value = null;
        } else {
            setYear(object.target.value);
        }
    }

    const handleButtonClick = (object) => {
        const now = moment();
        const enteredDate = moment(year+'-'+month+'-'+day);
        const diff = now.diff(enteredDate, 'months', false);
        const legalAgeInMonths = (legalAge * 12);
        if(diff >= legalAgeInMonths) {
            setIsOfLegalAge(true);
            onAgeEntered(true);
        } else {
            setFormTitle('SORRY YOU MUST BE 21 OR OLDER TO VIEW THIS SITE');
        }
    }


    return (
        <div className={classes.Container}>
                <form id="submit-form">
                    <div className={classes.FormTitle}>
                        {formTitle}
                    </div>
                    <div className={classes.FormSubtitle}>
                        You must be of legal age to enter this site.
                    </div>
                    <div className={classes.FormInputContainer}>
                        <input
                            required
                            autoComplete="false"                                    
                            name="month"
                            type="number"
                            inputMode="numeric"
                            placeholder="MM"
                            className={classes.InputBox}
                            pattern="[0-9]*"
                            maxLength="2"
                            max="12"
                            min="1"
                            onChange={handleChangeOnMonth}
                            />
                        <input
                            style={{marginLeft:'16px', marginRight:'16px'}}
                            name="day"
                            required
                            autoComplete="false"
                            type="string"
                            placeholder="DD"
                            inputMode="numeric"
                            className={classes.InputBox}
                            maxLength="2"
                            max="31"
                            onChange={handleChangeOnDay}
                            />                                
                        <input
                            name="year"
                            required
                            autoComplete="false"
                            inputMode="numeric"
                            type="string"
                            placeholder="YYYY"
                            className={classes.InputBox}
                            maxLength="4"
                            min="1900"
                            max="2022"
                            onChange={handleChangeOnYear}
                            />                                
                    </div>
                </form>
                <div className={classes.ButtonContainer}>
                    <Button onClick={handleButtonClick} btnText={'ENTER'} color={'#181748'}/>
                </div>                            

            </div>
    );

}

export default AgeGate;
